// @ts-ignore
export function debounce(func, timeout = 300) {
  let timer: NodeJS.Timeout;

  // @ts-ignore
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export interface ScrollToMiddleOptions {
  onlyIfBelow?: boolean;
}

export function scrollElementToMiddle(
  element: HTMLElement,
  options: ScrollToMiddleOptions = {}
): void {
  const elementRect = element.getBoundingClientRect();
  scrollPositionToMiddle(elementRect.top, options);
}

export function scrollElementToTop(element: HTMLElement): void {
  const elementRect = element.getBoundingClientRect();
  scrollPositionToTop(elementRect.top);
}

export function scrollPositionToMiddle(
  position: number,
  { onlyIfBelow }: ScrollToMiddleOptions = {}
) {
  const absoluteElementTop = position + window.pageYOffset;
  const middle = absoluteElementTop - window.innerHeight / 2;

  // scroll only if element is below middle
  if (position < middle && onlyIfBelow) {
    return;
  }

  window.scrollTo({
    top: middle,
    left: 0,
    behavior: 'smooth',
  });
}

export function scrollPositionToTop(position: number) {
  const top = position + window.pageYOffset;

  window.scrollTo({
    top,
    left: 0,
    behavior: 'smooth',
  });
}

export function getElementByClassName(
  element: Element,
  className: string
): HTMLElement {
  return element.getElementsByClassName(className)[0] as HTMLElement;
}
